export const colors_reports = [
  '#FF0000',
  '#C0C0C0',
  '#ff8016',
  '#8884d8',
  '#82ca9d',
];
